export default "__VITE_ASSET__CWzl8k3T__"